import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-edit-avatar-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule
  ],
  templateUrl: './edit-avatar-dialog.component.html',
  styleUrl: './edit-avatar-dialog.component.scss'
})
export class EditAvatarDialogComponent {
  currentAvatar = 'assets/avatar.png'; // Avatar actual
  defaultAvatars = [
    'assets/avatar.png',
    'assets/avatar.png',
    'assets/avatar.png',
    'assets/avatar.png',
    'assets/avatar.png',
    'assets/avatar.png',
    'assets/avatar.png'
  ];
  selectedAvatar: string | null = null;

  constructor(private dialogRef: MatDialogRef<EditAvatarDialogComponent>) {}

  selectAvatar(avatar: string) {
    this.selectedAvatar = avatar;
    console.log('selectedAvatar', this.selectedAvatar);
  }

  uploadAvatar() {
    // Lógica para subir una imagen desde el ordenador
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = (event: any) => {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          this.selectedAvatar = reader.result as string; // Asigna la imagen seleccionada.
        };
        reader.readAsDataURL(file);
      }
    };
    input.click();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  saveChanges() {
    if (this.selectedAvatar) {
      this.dialogRef.close(this.selectedAvatar);
    }
  }
}
